import React, { Component } from 'react';
import $ from 'jquery';
import Calendar from 'react-calendar'
import MonthView from 'react-calendar'
import { Glyphicon, ControlLabel, Alert, OverlayTrigger, Tooltip, Grid, Row, Col, Jumbotron, Button, Modal, FormGroup, FormControl, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import Loader from 'react-loader-advanced'

import _ from 'lodash'
import If from "../../utils/If"

import { fractionHoursListUtils } from "../../utils/fraction-work-hours"

//Date range picker
import DayPicker, { DateUtils } from 'react-day-picker';
import '../../statics/css/agenda.css'
import InputHour from '../../utils/input-hour';
//import '../../statics/css/time-picker.css'

//opcao 1: https://blog.flowandform.agency/create-a-custom-calendar-in-react-3df1bfd0b728
//opcao 2: https://github.com/wojtekmaj/react-calendar
//opcao 3: https://reactjsexample.com/a-calendar-to-select-available-time-slots/


class Calendary extends Component {

    static defaultProps = {
        numberOfMonths: 2,
    };

    constructor(props) {
        super(props);

        this.state = {
            date: new Date(),
            showModalMountSchedule: false,

            value_days_disponibilty: [],

            //data
            fraction_hour: 1,

            //modal

            addingIntervalsDay: '',

            dom_begin: "",
            dom_end: "",
            dom_intervals: [
                // {
                //     begin: "11:00",
                //     end: "12:00",
                // },
                // {
                //     begin: "15:00",
                //     end: "16:00",
                // },
                // {
                //     begin: "21:00",
                //     end: "22:00",
                // },
            ],

            seg_begin: "",
            seg_end: "",
            seg_intervals: [

            ],

            ter_begin: "",
            ter_end: "",
            ter_intervals: [

            ],

            qua_begin: "",
            qua_end: "",
            qua_intervals: [

            ],

            qui_begin: "",
            qui_end: "",
            qui_intervals: [

            ],

            sex_begin: "",
            sex_end: "",
            sex_intervals: [

            ],

            sab_begin: "",
            sab_end: "",
            sab_intervals: [

            ],

            loadModalMountSchedule: false,

            //Date range
            from: undefined,
            to: undefined,
            showRangePickerDate: true,

            showModalIntervalPick: false,

            beginHour: '',
            endHour: '',

            hour_interval1: '00',
            minutes_interval1: '00',
            hour_interval2: '00',
            minutes_interval2: '00',

            rerenderAuxInputHour: false,

        };

        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleResetClick = this.handleResetClick.bind(this);

    }

    handleDayClick(day) {
        const range = DateUtils.addDayToRange(day, this.state);
        this.setState(range);
    }
    handleResetClick() {

        this.setState({
            from: undefined,
            to: undefined,
        });
    }

    onChange = date => this.setState({ date })

    componentWillUnmount() {

    }

    getFirstDayMonth(month) {
        let d = new Date(2018, month, 1);
        return d;
    }

    getLastDayMonth(month) {
        let d = new Date(2018, month + 1, 0);
        return d;
    }

    clickDay(month, value) {
        console.log("MONTH: " + month);
        console.log("VALUE: " + value);
    }

    mountSchedule() {
        this.setState({
            showModalMountSchedule: true,
        })
    }

    handleCloseModalMountSchedule() {
        this.setState({
            showModalMountSchedule: false,
        })
    }

    getValidationHour(event) {

        let value = undefined;
        if (document.getElementsByName(event)[0]) {
            //console.log(document.getElementsByName(event)[0].name);
            //console.log(document.getElementsByName(event)[0].value);

            value = document.getElementsByName(event)[0].value;
        }

        if (value && value.length > 5) {
            value = value.substring(0, 5);
        }

        if (value) {
            if (value.length == 5 && !this.isValidHour(value)) {
                return 'error';
            } else if (value.length > 0 && value.length < 5) {
                return 'warning';
            } else if (this.isValidHour(value)) {
                return 'success';
            } else {
                return 'warning';
            }
        }

        return null;
    }

    isValidHour(hourStr) {

        let hour = parseInt(hourStr.substring(0, 2));
        let minutes = parseInt(hourStr.substring(3));

        let hourOk = false;
        let minutesOk = false;

        if (hour >= 0 && hour <= 23) {
            hourOk = true;
        }

        if (minutes >= 0 && minutes <= 59) {
            minutesOk = true;
        }

        if (hourOk && minutesOk) {
            return true;
        } else {
            return false;
        }
    }

    changeInputHourMask(event) {

        let value = event.value;
        let name = event.name;

        value = value.replace(/\D/g, "");
        value = value.replace(/:/g, "");

        if (value.length > 4) {
            value = value.substring(0, 4);
        }

        let result = value;
        if (value.length >= 3) {

            result = '';
            result += value.substring(0, 2);
            result += ":";
            result += value.substring(2);
        }

        this.setState({
            [name]: result,
        })

    }

    handleChangeDaysDisponibility(e) {
        this.setState({
            value_days_disponibilty: e,
        })
    }

    renderFractionHours() {

        return _.map(fractionHoursListUtils, (fraction) => {

            return (

                <ToggleButton value={fraction.key}>{fraction.name}</ToggleButton>

            )

        })

    }

    handleChangeFractionHour(event) {
        console.log(event)

        this.setState({
            fraction_hour: event,
            //fraction_hour_label: label,
        })

    }

    getFractionLabel() {

        let label = '';

        switch (this.state.fraction_hour) {
            case 1:
                label = "10 min";
                break;
            case 2:
                label = "15 min";
                break;
            case 3:
                label = "30 min";
                break;
            case 4:
                label = "60 min";
                break;
        }

        return (
            <span className="bold"> {label}</span>
        );
    }

    selectRangeDates() {
        let tooltip = document.getElementsByClassName('tooltip-picker-range-date');
        if (tooltip[0]) {
            tooltip[0].style.visibility = 'visible';
        }

        this.setState({
            showRangePickerDate: true,
        })
    }

    hideDateRangePicker() {
        let tooltip = document.getElementsByClassName('tooltip-picker-range-date');
        if (tooltip[0]) {
            tooltip[0].style.visibility = 'hidden';
        }

        this.setState({
            showRangePickerDate: false,
        })
    }

    addInterval(day) {

        let value = '';

        let begin = '';
        let end = '';

        let okToPut = true;

        switch (day) {
            case 'dom':
                if (this.state.dom_begin && this.state.dom_end) {
                    value = 'dom_intervals';
                    begin = this.state.dom_begin;
                    end = this.state.dom_end;
                } else {
                    okToPut = false;
                }

                break;
            case 'seg':
                if (this.state.seg_begin && this.state.seg_end) {
                    value = 'seg_intervals';
                    begin = this.state.seg_begin;
                    end = this.state.seg_end;
                } else {
                    okToPut = false;
                }

                break;
            case 'ter':
                if (this.state.ter_begin && this.state.ter_end) {
                    value = 'ter_intervals';
                    begin = this.state.ter_begin;
                    end = this.state.ter_end;
                } else {
                    okToPut = false;
                }

                break;
            case 'qua':
                if (this.state.qua_begin && this.state.qua_end) {
                    value = 'qua_intervals';
                    begin = this.state.qua_begin;
                    end = this.state.qua_end;
                } else {
                    okToPut = false;
                }

                break;
            case 'qui':
                if (this.state.qui_begin && this.state.qui_end) {
                    value = 'qui_intervals';
                    begin = this.state.qui_begin;
                    end = this.state.qui_end;
                } else {
                    okToPut = false;
                }

                break;
            case 'sex':
                if (this.state.sex_begin && this.state.sex_end) {
                    value = 'sex_intervals';
                    begin = this.state.sex_begin;
                    end = this.state.sex_end;
                } else {
                    okToPut = false;
                }

                break;
            case 'sab':
                if (this.state.sab_begin && this.state.sab_end) {
                    value = 'sab_intervals';
                    begin = this.state.sab_begin;
                    end = this.state.sab_end;
                } else {
                    okToPut = false;
                }

                break;

        }

        if (okToPut) {
            this.setState({
                beginHour: begin,
                endHour: end,

                hour_interval1: '00',
                minutes_interval1: '00',
                hour_interval2: '00',
                minutes_interval2: '00',

                addingIntervalsDay: value,
                showModalIntervalPick: true,

            })
        } else {
            this.setState({
                messageModal: "Informe o expediente do dia",
            })

            setTimeout(() => {

                if (this.state.messageModal == "Informe o expediente do dia") {
                    this.setState({
                        messageModal: '',
                    });
                }

            }, 5000);
        }


    }

    handleCloseModalAddIntervals() {
        this.setState({
            showModalIntervalPick: false,
        })
    }

    handleSaveInterval() {

        console.log("HOUR INTERVAL1: " + this.state.hour_interval1);
        console.log("MINUTES INTERVAL1: " + this.state.minutes_interval1);
        console.log("HOUR INTERVAL2: " + this.state.hour_interval2);
        console.log("MINUTES INTERVAL2: " + this.state.minutes_interval2);

        console.log("DAY: " + this.state.addingIntervalsDay);

        this.state[this.state.addingIntervalsDay].push({
            begin: this.state.hour_interval1 + ":" + this.state.minutes_interval1,
            end: this.state.hour_interval2 + ":" + this.state.minutes_interval2,
        });

        this.setState({
            [this.state.addingIntervalsDay]: this.state[this.state.addingIntervalsDay],
        }, () => {
            this.handleCloseModalAddIntervals();
        })

    }

    handleOnChangeHour(state_label, e) {

        //trocando a hora do primeiro input força-se o rerender do input auxiliar
        if (state_label == 'hour_interval1') {
            this.setState({
                [state_label]: e.target.value,
                rerenderAuxInputHour: !this.state.rerenderAuxInputHour,
            })
        } else {
            this.setState({
                [state_label]: e.target.value,
            })
        }


    }

    renderIntervals(day) {


        return _.map(this.state[day], (interval, index) => {

            return (
                <div className="interval-rendered">
                    <p>(</p>
                    <p className="red">{interval.begin} às {interval.end}h</p>
                    <p>)</p>
                </div>
            )
        });
    }

    renderMessage(message) {
        return (
            <p>
                <strong>{message.substring(0, message.indexOf(" "))}</strong>
                {message.substring(message.indexOf(" "))}
            </p>
        )
    }

    applySchedule() {

        console.log("FROM: " + this.state.from);
        console.log("TO: " + this.state.to);
        let datesToApply = [];

        for (let d = new Date(this.state.from); d <= new Date(this.state.to); d.setDate(d.getDate() + 1)) {
            console.log(d + " - " + (d.getDay() + 1));
            if (this.state.value_days_disponibilty.includes((d.getDay() + 1))) {
                datesToApply.push(d);
            }
        }

        console.log(datesToApply);

    }

    render() {

        const { from, to } = this.state;
        const modifiers = { start: from, end: to };

        return (
            <div className="calendar-page">

                <Jumbotron>
                    <h2>Adicionar disponibilidade</h2>
                    <p>Informe a sua disponibilidade e o seu horário de expediente para cada dia da semana</p>
                    <p>
                        <Button bsStyle="primary" onClick={() => this.mountSchedule(undefined)}>Montar agenda</Button>
                    </p>
                </Jumbotron>

                <Row className="show-grid">
                    <Col xs={12} md={4} sm={12}>
                        <p className="label-month">Janeiro</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(0, value) }
                            }
                            minDate={this.getFirstDayMonth(0)}
                            maxDate={this.getLastDayMonth(0)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>

                    <Col xs={12} md={4} sm={12} className="space-month">
                        <p className="label-month">Fevereiro</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(1, value) }
                            }
                            minDate={this.getFirstDayMonth(1)}
                            maxDate={this.getLastDayMonth(1)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>

                    <Col xs={12} md={4} sm={12} className="space-month">
                        <p className="label-month">Março</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(2, value) }
                            }
                            minDate={this.getFirstDayMonth(2)}
                            maxDate={this.getLastDayMonth(2)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>
                </Row>

                <Row className="show-grid space-top">
                    <Col xs={12} md={4} sm={12}>
                        <p className="label-month">Abril</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(3, value) }
                            }
                            minDate={this.getFirstDayMonth(3)}
                            maxDate={this.getLastDayMonth(3)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>

                    <Col xs={12} md={4} sm={12} className="space-month">
                        <p className="label-month">Maio</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(4, value) }
                            }
                            minDate={this.getFirstDayMonth(4)}
                            maxDate={this.getLastDayMonth(4)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>

                    <Col xs={12} md={4} sm={12} className="space-month">
                        <p className="label-month">Junho</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(5, value) }
                            }
                            minDate={this.getFirstDayMonth(5)}
                            maxDate={this.getLastDayMonth(5)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>
                </Row>

                <Row className="show-grid space-top">
                    <Col xs={12} md={4} sm={12}>
                        <p className="label-month">Julho</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(6, value) }
                            }
                            minDate={this.getFirstDayMonth(6)}
                            maxDate={this.getLastDayMonth(6)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>

                    <Col xs={12} md={4} sm={12} className="space-month">
                        <p className="label-month">Agosto</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(7, value) }
                            }
                            minDate={this.getFirstDayMonth(7)}
                            maxDate={this.getLastDayMonth(7)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>

                    <Col xs={12} md={4} sm={12} className="space-month">
                        <p className="label-month">Setembro</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(8, value) }
                            }
                            minDate={this.getFirstDayMonth(8)}
                            maxDate={this.getLastDayMonth(8)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>
                </Row>

                <Row className="show-grid space-top">
                    <Col xs={12} md={4} sm={12}>
                        <p className="label-month">Outubro</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(9, value) }
                            }
                            minDate={this.getFirstDayMonth(9)}
                            maxDate={this.getLastDayMonth(9)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>

                    <Col xs={12} md={4} sm={12} className="space-month">
                        <p className="label-month">Novembro</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(10, value) }
                            }
                            minDate={this.getFirstDayMonth(10)}
                            maxDate={this.getLastDayMonth(10)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>

                    <Col xs={12} md={4} sm={12} className="space-month">
                        <p className="label-month">Dezembro</p>
                        <Calendar
                            onClickDay={
                                (value) => { this.clickDay(11, value) }
                            }
                            minDate={this.getFirstDayMonth(11)}
                            maxDate={this.getLastDayMonth(11)}
                            showNavigation={false}
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </Col>
                </Row>

                <Modal show={this.state.showModalMountSchedule}
                    className="modal-mount-schedule">


                    <Loader show={this.state.loadModalMountSchedule} message={<div className="loader"></div>}
                        backgroundStyle={{ backgroundColor: 'none' }}
                        foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>
                        <Modal.Header>
                            <Modal.Title>
                                <Grid>
                                    <Row className="flex-row">
                                        <Col xs={6} md={6} className="no-p-left no-p-right text-left">
                                            <p className="no-m-bottom">Montar agenda</p>
                                        </Col>
                                        <Col xs={6} md={6} className="no-p-left no-p-right text-right">
                                            <OverlayTrigger placement="bottom"
                                                delayShow="50"
                                                delayHide="300000"
                                                trigger="focus"
                                                overlay={
                                                    <Tooltip className={`tooltip-picker-range-date ${this.state.showRangePickerDate ? 'show-tooltip' : ''}`}>

                                                        <DayPicker
                                                            className="Selectable"
                                                            numberOfMonths={this.props.numberOfMonths}
                                                            months={["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]}
                                                            weekdaysShort={["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]}
                                                            //weekdaysShort={["Do", "Se", "Te", "Qa", "Qi", "Se", "Sa"]}
                                                            weekdaysLong={["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"]}
                                                            selectedDays={[from, { from, to }]}
                                                            modifiers={modifiers}
                                                            onDayClick={this.handleDayClick}
                                                        />

                                                        <div className="buttons-tooltip-bottom">
                                                            <Button className="clean" bsStyle="danger" onClick={() => this.handleResetClick()}>Limpar</Button>
                                                            <Button onClick={() => this.hideDateRangePicker()}>Fechar</Button>
                                                            {/* <Button bsStyle="primary" onClick={() => this.selectRangeDates()}>Salvar</Button> */}
                                                        </div>


                                                    </Tooltip >
                                                }>

                                                <div className="period-date-range-input">

                                                    <p className="secondaryFontColor no-m-bottom">Selecione o período</p>

                                                    <FormControl
                                                        name="period_mount_schedule"
                                                        type="text"
                                                        className="textarea-fixed"
                                                        value={(from ? from.toLocaleDateString("pt-BR") : '') + " - " + (to ? to.toLocaleDateString("pt-BR") : '')}
                                                        placeholder="Início"
                                                        onClick={() => this.selectRangeDates()}

                                                    />
                                                </div>


                                                {/* <Button bsStyle="primary" onClick={() => this.selectRangeDates()}>Selecionar período</Button> */}
                                            </OverlayTrigger>
                                        </Col>
                                    </Row>

                                </Grid>

                            </Modal.Title>

                        </Modal.Header>

                        <Modal.Body>

                            {this.state.messageModal && this.state.messageModal != '' ?
                                <Alert bsStyle="warning">
                                    {this.renderMessage(this.state.messageModal)}
                                </Alert>
                                : null}
                            <p className="no-m-bottom bold">Selecione os dias para aplicar a replicação de agenda</p>
                            <ToggleButtonGroup type="checkbox"
                                value={this.state.value_days_disponibilty}
                                onChange={(e) => this.handleChangeDaysDisponibility(e)}>
                                <ToggleButton value={1}>Dom</ToggleButton>
                                <ToggleButton value={2}>Seg</ToggleButton>
                                <ToggleButton value={3}>Ter</ToggleButton>
                                <ToggleButton value={4}>Qua</ToggleButton>
                                <ToggleButton value={5}>Qui</ToggleButton>
                                <ToggleButton value={6}>Sex</ToggleButton>
                                <ToggleButton value={7}>Sab</ToggleButton>
                            </ToggleButtonGroup>

                            <br />
                            <br />

                            <FormGroup controlId="formControlsDescriptionTraining">
                                <ControlLabel>Fração de horário</ControlLabel>
                                <br />
                                <ToggleButtonGroup type="radio"
                                    name="fraction_hour_radio"
                                    value={this.state.fraction_hour}
                                    onChange={(e) => this.handleChangeFractionHour(e)}>
                                    {this.renderFractionHours()}
                                </ToggleButtonGroup>

                                <p className="extra-label">As aulas poderão ser marcadas com a fração de {this.getFractionLabel()}</p>

                            </FormGroup>

                            <p className="no-m-bottom bold label-expediences">Expedientes</p>

                            <div className="row seven-cols rows-days-replication">
                                <div className="col-md-1 day-expedience">
                                    <p className="no-m-bottom">Domingo</p>
                                    <div className="form-day-disponibility">

                                        <FormGroup controlId="dom_begin" className="no-m-bottom"
                                            validationState={this.getValidationHour("dom_begin")}>
                                            <FormControl
                                                name="dom_begin"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.dom_begin}
                                                placeholder="Início"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>

                                        <p className="label-as"> ás </p>

                                        <FormGroup controlId="dom_end" className="no-m-bottom"
                                            validationState={this.getValidationHour("dom_end")}>
                                            <FormControl
                                                name="dom_end"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.dom_end}
                                                placeholder="Fim"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>
                                        <Button className="btn-add-interval" bsStyle="warning" onClick={() => this.addInterval("dom")}><Glyphicon glyph="plus" /> Intervalo</Button>

                                        <div className="intervals">
                                            {this.renderIntervals('dom_intervals')}
                                        </div>
                                    </div>
                                    <If test={!this.state.value_days_disponibilty.includes(1)}>
                                        <div className="orverlay-day-expedience"></div>
                                    </If>
                                </div>
                                <div className="col-md-1 day-expedience">
                                    <p className="no-m-bottom">Segunda</p>
                                    <div className="form-day-disponibility">
                                        <FormGroup controlId="seg_begin" className="no-m-bottom"
                                            validationState={this.getValidationHour("seg_begin")}>
                                            <FormControl
                                                name="seg_begin"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.seg_begin}
                                                placeholder="Início"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>

                                        <p className="label-as"> ás </p>

                                        <FormGroup controlId="seg_end" className="no-m-bottom"
                                            validationState={this.getValidationHour("seg_end")}>
                                            <FormControl
                                                name="seg_end"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.seg_end}
                                                placeholder="Fim"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>
                                        <Button className="btn-add-interval" bsStyle="warning" onClick={() => this.addInterval("seg")}><Glyphicon glyph="plus" /> Intervalo</Button>
                                        <div className="intervals">
                                            {this.renderIntervals('seg_intervals')}
                                        </div>
                                    </div>
                                    <If test={!this.state.value_days_disponibilty.includes(2)}>
                                        <div className="orverlay-day-expedience"></div>
                                    </If>
                                </div>
                                <div className="col-md-1 day-expedience">
                                    <p className="no-m-bottom">Terça</p>
                                    <div className="form-day-disponibility">
                                        <FormGroup controlId="ter_begin" className="no-m-bottom"
                                            validationState={this.getValidationHour("ter_begin")}>
                                            <FormControl
                                                name="ter_begin"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.ter_begin}
                                                placeholder="Início"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>

                                        <p className="label-as"> ás </p>

                                        <FormGroup controlId="ter_end" className="no-m-bottom"
                                            validationState={this.getValidationHour("ter_end")}>
                                            <FormControl
                                                name="ter_end"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.ter_end}
                                                placeholder="Fim"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>

                                        <Button className="btn-add-interval" bsStyle="warning" onClick={() => this.addInterval("ter")}><Glyphicon glyph="plus" /> Intervalo</Button>
                                        <div className="intervals">
                                            {this.renderIntervals('ter_intervals')}
                                        </div>
                                    </div>
                                    <If test={!this.state.value_days_disponibilty.includes(3)}>
                                        <div className="orverlay-day-expedience"></div>
                                    </If>
                                </div>
                                <div className="col-md-1 day-expedience">
                                    <p className="no-m-bottom">Quarta</p>
                                    <div className="form-day-disponibility">
                                        <FormGroup controlId="qua_begin" className="no-m-bottom"
                                            validationState={this.getValidationHour("qua_begin")}>
                                            <FormControl
                                                name="qua_begin"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.qua_begin}
                                                placeholder="Início"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>

                                        <p className="label-as"> ás </p>

                                        <FormGroup controlId="qua_end" className="no-m-bottom"
                                            validationState={this.getValidationHour("qua_end")}>
                                            <FormControl
                                                name="qua_end"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.qua_end}
                                                placeholder="Fim"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>
                                        <Button className="btn-add-interval" bsStyle="warning" onClick={() => this.addInterval("qua")}><Glyphicon glyph="plus" /> Intervalo</Button>
                                        <div className="intervals">
                                            {this.renderIntervals('qua_intervals')}
                                        </div>
                                    </div>
                                    <If test={!this.state.value_days_disponibilty.includes(4)}>
                                        <div className="orverlay-day-expedience"></div>
                                    </If>
                                </div>
                                <div className="col-md-1 day-expedience">
                                    <p className="no-m-bottom">Quinta</p>
                                    <div className="form-day-disponibility">
                                        <FormGroup controlId="qui_begin" className="no-m-bottom"
                                            validationState={this.getValidationHour("qui_begin")}>
                                            <FormControl
                                                name="qui_begin"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.qui_begin}
                                                placeholder="Início"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>

                                        <p className="label-as"> ás </p>

                                        <FormGroup controlId="qui_end" className="no-m-bottom"
                                            validationState={this.getValidationHour("qui_end")}>
                                            <FormControl
                                                name="qui_end"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.qui_end}
                                                placeholder="Fim"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>
                                        <Button className="btn-add-interval" bsStyle="warning" onClick={() => this.addInterval("qui")}><Glyphicon glyph="plus" /> Intervalo</Button>
                                        <div className="intervals">
                                            {this.renderIntervals('qui_intervals')}
                                        </div>
                                    </div>
                                    <If test={!this.state.value_days_disponibilty.includes(5)}>
                                        <div className="orverlay-day-expedience"></div>
                                    </If>
                                </div>
                                <div className="col-md-1 day-expedience">
                                    <p className="no-m-bottom">Sexta</p>
                                    <div className="form-day-disponibility">
                                        <FormGroup controlId="sex_begin" className="no-m-bottom"
                                            validationState={this.getValidationHour("sex_begin")}>
                                            <FormControl
                                                name="sex_begin"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.sex_begin}
                                                placeholder="Início"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>

                                        <p className="label-as"> ás </p>

                                        <FormGroup controlId="sex_end" className="no-m-bottom"
                                            validationState={this.getValidationHour("sex_end")}>
                                            <FormControl
                                                name="sex_end"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.sex_end}
                                                placeholder="Fim"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>
                                        <Button className="btn-add-interval" bsStyle="warning" onClick={() => this.addInterval("sex")}><Glyphicon glyph="plus" /> Intervalo</Button>
                                        <div className="intervals">
                                            {this.renderIntervals('sex_intervals')}
                                        </div>
                                    </div>
                                    <If test={!this.state.value_days_disponibilty.includes(6)}>
                                        <div className="orverlay-day-expedience"></div>
                                    </If>
                                </div>
                                <div className="col-md-1 day-expedience">
                                    <p className="no-m-bottom">Sábado</p>
                                    <div className="form-day-disponibility">
                                        <FormGroup controlId="sab_begin" className="no-m-bottom"
                                            validationState={this.getValidationHour("sab_begin")}>
                                            <FormControl
                                                name="sab_begin"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.sab_begin}
                                                placeholder="Início"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>

                                        <p className="label-as"> ás </p>

                                        <FormGroup controlId="sab_end" className="no-m-bottom"
                                            validationState={this.getValidationHour("sab_end")}>
                                            <FormControl
                                                name="sab_end"
                                                type="text"
                                                className="textarea-fixed"
                                                value={this.state.sab_end}
                                                placeholder="Fim"
                                                onChange={(event) => this.changeInputHourMask(event.target)}
                                            />
                                            <FormControl.Feedback />
                                        </FormGroup>
                                        <Button className="btn-add-interval" bsStyle="warning" onClick={() => this.addInterval("sab")}><Glyphicon glyph="plus" /> Intervalo</Button>
                                        <div className="intervals">
                                            {this.renderIntervals('sab_intervals')}
                                        </div>
                                    </div>
                                    <If test={!this.state.value_days_disponibilty.includes(7)}>
                                        <div className="orverlay-day-expedience"></div>
                                    </If>
                                </div>
                            </div>


                        </Modal.Body>

                        <Modal.Footer>
                            <Button onClick={() => this.handleCloseModalMountSchedule()}>Fechar</Button>
                            <Button bsStyle="primary" onClick={() => this.applySchedule()}>Aplicar</Button>
                        </Modal.Footer>

                    </Loader>
                </Modal>

                <Modal show={this.state.showModalIntervalPick}
                    className="input-interval-schedule">

                    <Modal.Header>
                        <Modal.Title>
                            Selecione o intervalo
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div>
                            <InputHour
                                reverse={false}
                                paramBeginHour={this.state.beginHour}
                                paramEndHour={this.state.endHour}
                                stepMinutes={this.state.fraction_hour}
                                hour={this.state.hour_interval1}
                                minutes={this.state.minutes_interval1}
                                onChangeHour={(label, e) => { this.handleOnChangeHour(label + '1', e) }}
                                noMarginBottom={true} />
                            <p className="no-m-bottom">ás</p>
                            <InputHour
                                reverse={true}
                                rerender={this.state.rerenderAuxInputHour}
                                paramBeginHour={this.state.beginHour}
                                paramEndHour={this.state.endHour}
                                stepMinutes={this.state.fraction_hour}
                                hour={this.state.hour_interval2}
                                minutes={this.state.minutes_interval2}
                                onChangeHour={(label, e) => { this.handleOnChangeHour(label + '2', e) }}
                                noMarginBottom={true} />
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={() => this.handleCloseModalAddIntervals()}>Fechar</Button>
                        <Button bsStyle="warning" onClick={() => this.handleSaveInterval()}>Salvar</Button>
                    </Modal.Footer>

                </Modal>

            </div>
        );
    }
}

export default Calendary


// WEBPACK FOOTER //
// src/components/agenda/calendar.js